export const UNITS = 'in' // Always use 'in' because it's easier to convert metrics results than it is scaling the facility
